import { useContext } from 'react';
import { FileContext } from 'contexts/file_context';

const useFile = () => {
    return useContext(FileContext);
};

export default useFile;
